









import Vue from 'vue';
import Component from 'vue-class-component';
import { Swipe, SwipeItem, Lazyload } from 'vant';
Vue.use(Swipe)
.use(SwipeItem)
.use(Lazyload)

@Component
export default class Health extends Vue{

    jkzl=[{
        url:'https://mp.weixin.qq.com/s/BggHg7BRbzlsMTF7xmAGcA',
        imgUrl:'http://yths.zgftlm.com/static/j1.png',
        name:'弁言'
    },{
        url:'https://mp.weixin.qq.com/s/sDhIQZGgKPFWu_HJi8E2lA',
        imgUrl:'http://yths.zgftlm.com/static/j2.png',
        name:'生病有因'
    },{
        url:'https://mp.weixin.qq.com/s/TwZByQDPVIW__EElIURJyg',
        imgUrl:'http://yths.zgftlm.com/static/j3.png',
        name:'去病有方'
    },{
        url:'https://mp.weixin.qq.com/s/rpLXWjbTX76gXSn3sxqS0Q',
        imgUrl:'http://yths.zgftlm.com/static/j4.png',
        name:'防病有道'
    }]

    mounted(){
        document.title="健康之理"
    }

}
